// Dev-only preview: renders the share-card canvases to <img> so the states
// gallery can screenshot them (§13.7 share-card-score / share-card-dispute).

import { useEffect, useState } from "react";
import { renderScoreCard, renderDisputeCard } from "../lib/shareCard.ts";

export function ShareCardPreview() {
  const [score, setScore] = useState<string>("");
  const [dispute, setDispute] = useState<string>("");

  useEffect(() => {
    const s = renderScoreCard({
      nameA: "Dave",
      nameB: "Sarah",
      score: 79,
      tier: "great double bill",
      canon: [
        { title: "Aftersun", year: 2022, uri: "boxd.it/kx1a" },
        { title: "Parasite", year: 2019, uri: "boxd.it/par1" },
        { title: "Moonlight", year: 2016, uri: "boxd.it/mnl1" },
      ],
    });
    setScore(s.toDataURL("image/png"));
    const d = renderDisputeCard({
      nameA: "Dave",
      nameB: "Sarah",
      title: "The Room",
      year: 2003,
      ratingA: 5,
      ratingB: 0.5,
    });
    setDispute(d.toDataURL("image/png"));
  }, []);

  return (
    <div className="flex flex-wrap gap-6">
      {score && (
        <img data-testid="share-card-score" src={score} alt="score card" className="w-64 rounded-lg border border-border-strong" />
      )}
      {dispute && (
        <img data-testid="share-card-dispute" src={dispute} alt="dispute card" className="w-64 rounded-lg border border-border-strong" />
      )}
    </div>
  );
}
